import * as React from 'react'
import moment from 'moment'
import { TimePicker as AnTimePicker } from 'antd'
import fieldProps from './fieldProps'

const format = 'HH:mm'
// const monthFormat = 'YYYY/MM';

const Timepicker = (props: any) => {
  const { onChange, value, placeholder, style , disabled } = props
  return (
    <AnTimePicker
      disabled={disabled}
      popupClassName={'lp-timepicker'}
      onSelect={m => onChange(m ? m.format(format) : m)}
      onChange={w => {
        if (w === null) {
          onChange(null)
        }
      }}
      value={value ? (moment(value, format) as any) : null}
      format={format}
      style={style}
      placeholder={placeholder}
    />
  )
}

export default fieldProps(Timepicker)
